import { useMemo, useState } from 'react';
import StorefrontUsageTrackerContext from '../context/StorefrontUsageTrackerContext';
// @ts-expect-error module is untyped
import { getUsageTracker } from '../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
const makeTrackEvent = (usageTracker, defaultEventProperties) => (eventName, eventProperties = {}) => {
  usageTracker.track(eventName, Object.assign({}, defaultEventProperties, eventProperties));
};
export default function StorefrontUsageTrackerProvider({
  children
}) {
  const [defaultEventProperties, setDefaultEventProperties] = useState({});
  const usageTrackerContextValue = useMemo(() => {
    const trackEvent = makeTrackEvent(getUsageTracker(), defaultEventProperties);
    return {
      trackEvent,
      trackPageview: trackEvent.bind(null, 'pageView'),
      trackDetailsPageview: trackEvent.bind(null, 'details-pageview'),
      trackFilterView: trackEvent.bind(null, 'storefront-filter-view'),
      trackInteraction: (action, eventProperties = {}) => trackEvent('interaction', Object.assign({}, eventProperties, {
        action
      })),
      trackDetailsInteraction: (action, eventProperties = {}) => trackEvent('details-interaction', Object.assign({}, eventProperties, {
        action
      })),
      setDefaultEventProperties
    };
  }, [defaultEventProperties]);
  return /*#__PURE__*/_jsx(StorefrontUsageTrackerContext.Provider, {
    value: usageTrackerContextValue,
    children: children
  });
}